// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".conference-simple-info-container[data-v-0a69c43f]{background:#fff;padding:5px 10px;width:300px;border-radius:2px;box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19)}.title[data-v-0a69c43f]{padding-bottom:10px}.info-item[data-v-0a69c43f]{display:flex;font-size:14px}.info-item .name[data-v-0a69c43f]{width:80px;color:#2d3033}.info-item .value[data-v-0a69c43f]{flex:1 1 auto;color:grey}", ""]);
// Exports
module.exports = exports;
